const rootClass = 'weet-components-checkbox';
export { rootClass };
